"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSelectedValueCountry = exports.InitCountry = exports.CountriesLoaded = exports.cbCountryOfDestination = exports.cbCountryOfOrigine = exports.tbCountryOfDestination = exports.tbCountryOfOrigine = void 0;
var Aanvraag = require("../Aanvraag");
var Algemeen = require("../Algemeen");
var Combobox = require("../Combobox");
var pnlCountryOfOrigine;
var pnlCountryOfDestination;
var CountriesAll;
exports.CountriesLoaded = false;
//INIT
function InitCountry() {
    pnlCountryOfOrigine = $('#ctl00_cphBody_pnlCountryOfOrigine');
    exports.tbCountryOfOrigine = $('#ctl00_cphBody_tbCountryOfOrigine');
    Algemeen.PopupControl(exports.tbCountryOfOrigine, pnlCountryOfOrigine);
    pnlCountryOfDestination = $('#ctl00_cphBody_pnlCountryOfDestination');
    exports.tbCountryOfDestination = $('#ctl00_cphBody_tbCountryOfDestination');
    Algemeen.PopupControl(exports.tbCountryOfDestination, pnlCountryOfDestination);
    exports.cbCountryOfOrigine = new Combobox.ComboBox(exports.tbCountryOfOrigine, pnlCountryOfOrigine, FilterAndFillCountry, tbCountryOnblur, 'divDropDownItem', 'divDropDownItemInFocus');
    exports.cbCountryOfDestination = new Combobox.ComboBox(exports.tbCountryOfDestination, pnlCountryOfDestination, FilterAndFillCountry, tbCountryOnblur, 'divDropDownItem', 'divDropDownItemInFocus');
    Algemeen.CallWebServiceGetGeneric('GetCountries', OnSuccessGetCountries);
}
exports.InitCountry = InitCountry;
//GET DATA
function OnSuccessGetCountries(data, status) {
    Algemeen.CheckSessionTimeout(data);
    CountriesAll = data.d;
    if (Aanvraag.EditMode) {
        SetSelectedValueCountry(Aanvraag.AanvraagObj.CountryOfOrigine, exports.cbCountryOfOrigine);
        SetSelectedValueCountry(Aanvraag.AanvraagObj.CountryOfDestination, exports.cbCountryOfDestination);
    }
    Algemeen.fillDropDownGeneric(exports.cbCountryOfOrigine, data.d);
    Algemeen.fillDropDownGeneric(exports.cbCountryOfDestination, data.d);
    exports.CountriesLoaded = true;
    Aanvraag.CheckAllLoaded();
}
//FILTER DATA
function FilterAndFillCountry(cb) {
    Algemeen.FilterAndFillGeneric(cb, CountriesAll);
}
//EVENTS
function tbCountryOnblur(tbValue) {
    return Algemeen.tbGenericOnblur(tbValue, CountriesAll);
}
function SetSelectedValueCountry(value, cb) {
    cb.selectedValue = value;
    for (var i = 0; i < CountriesAll.length; i++) {
        if (CountriesAll[i].Code == value) {
            cb.$tb.val(CountriesAll[i].Description);
            break;
        }
    }
}
exports.SetSelectedValueCountry = SetSelectedValueCountry;
